const handleGetLocation = async () => {
  try {
    const uri =
      "https://api.ipgeolocation.io/ipgeo?apiKey=d61f7d6f0a494c72bbd1d3145ba444d5";
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        DNT: "1",
      },
    };

    const res = await fetch(uri, options);
    if (!res.ok) {
      throw new Error(
        `Failed to fetch location: ${res.status} ${res.statusText}`
      );
    }

    return await res.json();
  } catch (error) {
    console.error("Error fetching location:", error);
    return {}; // Return an empty object on failure
  }
};

export default handleGetLocation;
